<template>
  <div class="home">
    <!-- // Outer Ring -->
    <div class="outer" ref="outer">
      <div class="circle" ref="circle"></div>
      <div class="inner" ref="inner">
        <!-- Score -->
        <div class="score" ref="score">
          {{ score }}
        </div>
      </div>
    </div>

    <!-- Red Rectangle -->
    <div class="ticker" ref="ticker" id="ticker">
      <span ref="rect"></span>
    </div>

    <!-- Form -->
    <div v-show="gameover" class="formContainer">
      <form action="" class="form">
        <input
          v-model="name"
          minlength="1"
          type="text"
          placeholder="Your Name"
          class="name"
          ref="nameInput"
          id="nameInput"
        />
      </form>
      <button class="submit appbtn" @click="postScore()">🏆 Submit</button>
      <button class="replay appbtn" @click="replay()">🔄️ Replay</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Home",
  data() {
    return {
      tickerDeg: 0,
      rotation: "clockwise",
      speed: 7,
      tickerIncrement: 1,
      gameover: false,
      name: "",
      score: 0,
      previousDeg: 180,
      coinWidth: 14,
      newCoinBuffer: 40,
    };
  },
  created() {
    document.body.style.overflow = "hidden";
  },
  mounted() {
    if (window.screen.width < 803) {
      this.calcDimensions();
    }
    window.addEventListener("resize", () => {
      if (window.screen.width < 803) {
        this.calcDimensions();
      }
    });

    window.onkeydown = function (e) {
      return !(e.keyCode == 32 && e.target == document.body);
    };
    document.addEventListener("keydown", this.keyListener, true);
    document.addEventListener("click", this.clickListener, true);
    document.addEventListener("touchstart", this.touchListener, true);
    this.rotateClockwise();

    this.$refs.ticker.style.transform = `rotate(${this.randomDegrees()}deg)`;

    // SET INITIAL POSITION OF GOLD COIN
    if (this.$refs.outer) {
      this.$refs.outer.style.transform = `rotate(${this.previousDeg}deg)`;
    }
  },
  methods: {
    burstAnim(coords) {
      const circleRect = this.$refs.circle.getBoundingClientRect();
      const RADIUS = circleRect.width / 1.5;
      const burst = new mojs.Burst({
        left: 0,
        top: 0,
        radius: { 4: RADIUS },
        angle: 45,
        count: 14,
        timeline: { delay: 0 },
        children: {
          radius: 1.7,
          fill: [
            { "##ffd700": "#ffd700" },
            { "#ffd700": "#ffd700" },
            { "#ffd700": "#ffd700" },
            { "#ffd700": "#ffd700" },
          ],
          scale: { 1: 0, easing: "quad.in" },
          pathScale: [0.8, null],
          degreeShift: [13, null],
          duration: [150, 300],
          easing: "quint.out",
          // speed: .1
        },
      });

      burst.tune(coords).replay();
    },
    calcDimensions() {
      let h = window.screen.height;
      let w = window.screen.width;
      let shortSide = Math.min(h, w);

      this.$refs.outer.style.width = `${shortSide - 3}px`;
      this.$refs.outer.style.height = `${shortSide - 3}px`;

      this.$refs.inner.style.width = `${(35 / 50) * shortSide - 3}px`;
      this.$refs.inner.style.height = `${(35 / 50) * shortSide - 3}px`;

      this.$refs.circle.style.width = `${(7.45 / 50) * shortSide}px`;
      this.$refs.circle.style.height = `${(7.45 / 50) * shortSide}px`;

      this.$refs.ticker.style.width = `${shortSide - 3}px`;
      this.$refs.ticker.style.height = `${shortSide - 3}px`;

      this.$refs.rect.style.width = `${(3 / 50) * shortSide}px`;
      this.$refs.rect.style.height = `${(7.5 / 50) * shortSide}px`;
    },
    randomDegrees(min = 1, max = 360) {
      let num = Math.floor(Math.random() * (max - min + 1) + min);
      return num <= this.previousDeg + this.newCoinBuffer &&
        num >= this.previousDeg - this.newCoinBuffer
        ? this.randomDegrees(min, max)
        : num;
    },
    rotateClockwise() {
      this.clockwise = setInterval(() => {
        this.tickerDeg += this.tickerIncrement;
        if (this.$refs.ticker) {
          this.$refs.ticker.style.transform = `rotate(${this.tickerDeg}deg)`;
        }
      }, this.speed);
    },
    rotateCounterClockwise() {
      this.counter = setInterval(() => {
        this.tickerDeg -= this.tickerIncrement;
        if (this.$refs.ticker) {
          this.$refs.ticker.style.transform = `rotate(${this.tickerDeg}deg)`;
        }
      }, this.speed);
    },
    checkIntersection() {
      if (this.$refs.ticker) {
        let tickerDeg = parseInt(
          this.$refs.ticker.style.transform.match(/-?\d+/g)[0]
        );
        let outerDeg = parseInt(
          this.$refs.outer.style.transform.match(/\d+/g)[0]
        );

        if (tickerDeg < 0) {
          while (tickerDeg < 0) {
            tickerDeg += 360;
          }
          this.ifIntersecting(tickerDeg, outerDeg);
        } else {
          this.ifIntersecting(tickerDeg, outerDeg);
        }
      }
    },
    ifIntersecting(tickerDeg, outerDeg) {
      tickerDeg = tickerDeg % 360;

      // When coin straddles 12'oclock position
      if (outerDeg <= this.coinWidth) {
        let leftEdge = 360 - (this.coinWidth - outerDeg);
        let rightEdge = outerDeg + this.coinWidth;
        if (tickerDeg >= leftEdge || tickerDeg <= rightEdge) {
          this.correct();
        } else {
          this.gameOver();
        }
      } else if (outerDeg >= 360 - this.coinWidth) {
        let leftEdge = outerDeg - this.coinWidth;
        let rightEdge = this.coinWidth - (360 - outerDeg);
        if (tickerDeg >= leftEdge || tickerDeg <= rightEdge) {
          this.correct();
        } else {
          this.gameOver();
        }
      } else {
        if (
          tickerDeg >= outerDeg - this.coinWidth &&
          tickerDeg <= outerDeg + this.coinWidth
        ) {
          this.correct();
        } else {
          this.gameOver();
        }
      }
    },
    correct() {
      this.score += 10;
      this.tickerIncrement += 0.025;

      const circle = this.$refs.circle.getBoundingClientRect();
      const padding = circle.height / 2;
      const coords = { x: circle.x + padding, y: circle.y + padding };
      this.burstAnim(coords);

      var audio = new Audio(require("../assets/tap.wav"));
      audio.play();

      this.reverseDirection();

      // New position of GOLD COIN
      if (this.$refs.outer) {
        let randomDeg = this.randomDegrees();
        this.$refs.outer.style.transform = `rotate(${randomDeg}deg)`;
        this.previousDeg = randomDeg;
      }
    },
    gameOver() {
      this.gameover = true;
      var audio = new Audio(require("../assets/over.wav"));
      audio.play();
      clearInterval(this.clockwise);
      clearInterval(this.counter);
    },
    replay() {
      window.location.reload();
    },
    reverseDirection() {
      if (this.rotation == "clockwise") {
        clearInterval(this.clockwise);
        this.rotateCounterClockwise();
        this.rotation = "counter";
      } else {
        clearInterval(this.counter);
        this.rotateClockwise();
        this.rotation = "clockwise";
      }
    },
    keyListener(e) {
      const isLink = e.target.tagName.toLowerCase() === "a";
      if (this.gameover === false && !isLink) {
        if (e.code === "Space") {
          this.checkIntersection();
          return false;
        }
      }
    },
    clickListener(e) {
      const isLink = e.target.tagName.toLowerCase() === "a";
      if (this.gameover === false && !isLink) {
        this.checkIntersection();
      }
    },
    touchListener(e) {
      const isLink = e.target.tagName.toLowerCase() === "a";
      if (this.gameover === false && !isLink) {
        this.checkIntersection();
      }
    },
    postScore() {
      const data = {
        fields: {
          Name: `${this.name}`,
          Score: `${this.score}`,
          Timestamp: `${new Date()}`,
        },
      };
      const options = {
        headers: {
          Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_TOKEN}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .post(
          "https://api.airtable.com/v0/appZCLNwTZOQx1Rg9/leaderboard",
          data,
          options
        )
        .then(
          (r) => {
            this.$router.push({
              path: "leaderboard",
            });
          },
          (error) => {
            return error;
          }
        );
    },
  },
};
</script>

<style lang="scss" scoped src="@/assets/home.scss">
// @import './assets/home.scss';
</style>
